import SettingsPage from '@/components/settings'


export default function Settings() {
  return (

    <SettingsPage/>
  )
}
